import { FormControl, Grid, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { FetchAutocomplete, FetchAutocompleteChangeReason } from '@australiangreens/ag-internal-components';
import { AccordionField } from '@components/DrawerAccordion';
import Search from '@mui/icons-material/Search';
import { AutocompleteResultWithTooltip, MailingStatus } from '@/types';
import { useLookupMailing } from '@/criteriaLookups';

type MailingsFormProps = {
  onChangeMailing: (
    newValue: AutocompleteResultWithTooltip[],
    reason: FetchAutocompleteChangeReason,
    event: React.SyntheticEvent<Element, Event>
  ) => void;
  mailingValue: AutocompleteResultWithTooltip[];
  mailingStatus: MailingStatus;
  onChangeMailingStatus: (event: SelectChangeEvent<MailingStatus>) => void;
};

const MailingsForm = ({
  mailingValue = [] as AutocompleteResultWithTooltip[],
  onChangeMailing = () => {},
  mailingStatus = 'delivered',
  onChangeMailingStatus = () => {},
}: MailingsFormProps) => {
  const lookup = useLookupMailing();
  return (
    <>
      <AccordionField title="Received mailing">
        <FetchAutocomplete
          lookup={lookup}
          minLength={3}
          label="Add a mailing"
          value={mailingValue}
          onChange={onChangeMailing}
          data-testid="getfiltermailings"
          loadingText="Looking for mailings..."
          noOptionsText="No mailings found"
          popupIcon={<Search />}
          disableIconFlip
        />
      </AccordionField>
      <Grid>
        <em>Note: Mailings older than 3 months will not have delivery data</em>
      </Grid>
      <AccordionField
        title={
          mailingValue.length
            ? 'Options for the selected mailing(s)'
            : 'Select at least one received mailing to see more mailing options'
        }
      />
      {mailingValue.length !== 0 && (
        <AccordionField title="Mailing status" inputId={'mailing-status'}>
          <FormControl fullWidth>
            <Select
              labelId="mailing-status-label"
              value={mailingStatus}
              onChange={onChangeMailingStatus}
              variant="filled"
            >
              <MenuItem value={'delivered'}>Delivered</MenuItem>
              <MenuItem value={'unopened'}>Unopened</MenuItem>
              <MenuItem value={'opened'}>Opened</MenuItem>
            </Select>
          </FormControl>
        </AccordionField>
      )}
    </>
  );
};

export default MailingsForm;
